import styled from "styled-components";
import styles from "../controlBar/ControlBar.module.css";
import { useTheme } from "../../middleware/ThemeContext";

const ShortcutButton = ({
    icon,
    label,
    onClick,
    iconPostions = "left",
    textColor,
    backgroundColor,
    hoverBackgroundColor,
    style,
    height,
    fontSize,
    fontWeight
}: {
    // icon: string;
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
    iconPostions?: string;
    textColor?: string;
    backgroundColor?: string;
    hoverBackgroundColor?: string;
    style?: React.CSSProperties;
    height?: string;
    fontSize?: string;
    fontWeight?: number
}) => {
    const { theme } = useTheme();
    textColor = textColor || theme.colors.topBarsColorText
    return (
        <ButtonShortcut
            className={styles.shortcutButton}
            theme={theme}
            onClick={onClick}
            $height={height}
            $backgroundColor={backgroundColor}
            $hoverBackgroundColor={hoverBackgroundColor}
            style={style}
        >
            {/* <img src={icon} alt={label} className={styles.icon} /> */}
            {iconPostions === "left" && <>{icon}</>}
            {label ? <span className={styles.label} style={{ color: textColor, fontSize: fontSize, fontWeight: fontWeight }}>{label}</span> : null}
            {iconPostions === "right" && <>{icon}</>}
        </ButtonShortcut>
    );
}

const ButtonShortcut = styled('button')<{ $height?: string; $backgroundColor?: string; $hoverBackgroundColor?: string }>(({ theme, $height, $backgroundColor, $hoverBackgroundColor }) => ({
    height: $height || "40px",
    gap: 8,
    backgroundColor: $backgroundColor || 'transparent',
    '&:hover': {
        backgroundColor: $hoverBackgroundColor || theme.colors.topBarsColorHover,
    },
}));

export default ShortcutButton